
@switch (definition?.control) {
  @case ('table') {
    <soft-dynamic-table
      [definition]="definition?.definition"
      [rows]="values ?? []"
    ></soft-dynamic-table>
  }
  @case ('chips') {
    @for (value of values; track value) {
      <soft-chip>
        <soft-dynamic-object
          [definition]="definition?.definition"
          [value]="value"
        ></soft-dynamic-object>
      </soft-chip>
    }
  }
  @default {
    <soft-dynamic-list
      [definition]="definition?.definition"
      [items]="values ?? []"
    ></soft-dynamic-list>
  }
}
